import { useQuery } from "@tanstack/react-query";
import { usePageState, useSetPage } from "../utils/paginationStates";
import { useSelectedBuildingName } from "./buildingStates";
import { getBuildings } from "@/api/buildings/get-Buildings";

export const fetchBuildings = () => {
  const { pageSize } = usePageState();
  const { currentPage } = useSetPage();
  const { selectedBuildingName } = useSelectedBuildingName();

  const {
    data: buildings,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["buildings", currentPage, pageSize, selectedBuildingName],
    queryFn: () => getBuildings(currentPage, pageSize, selectedBuildingName),
  });

  return { buildings, isLoading, error, currentPage };
};
